import { render, staticRenderFns } from "./SistemManajemenAntreanComponent.vue?vue&type=template&id=5e1f6146&scoped=true&"
import script from "./SistemManajemenAntreanComponent.vue?vue&type=script&lang=js&"
export * from "./SistemManajemenAntreanComponent.vue?vue&type=script&lang=js&"
import style1 from "./SistemManajemenAntreanComponent.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e1f6146",
  null
  
)

export default component.exports